export { default } from './SliderGrafics';
